

const toggleGridEdit = () => ({
    type: 'GRID/TOGGLE_EDIT',
});

const setXOffset = (value: number) => ({
    type: 'GRID/SET_X_OFFSET',
    value,
});

const setYOffset = (value: number) => ({
    type: 'GRID/SET_Y_OFFSET',
    value,
});

const setXTiles = (value: number) => ({
    type: 'GRID/SET_X_TILES',
    value,
});

const setYTiles = (value: number) => ({
    type: 'GRID/SET_Y_TILES',
    value,
});

export {
    toggleGridEdit,
    setXOffset,
    setYOffset,
    setXTiles,
    setYTiles,
};
